import React, { useState } from 'react';
import { Modal, ModalBody, Label } from 'reactstrap';
import './index.css';
import { UserInput } from '../../CommonComponents';
import ModalService from '../../../services/ModalService';
import modalclose from '../../../images/close1.png';

const UpdateDispatchDetails = ({
  isOpen,
  toggle,
  bookOrderId,
  updateInvoice,
}) => {
  const [transporterName, setTransporterName] = useState('');
  const [transporterDetails, setTransporterDetails] = useState('');

  const submit = () => {
    if (!transporterName || !transporterDetails) {
      ModalService.openAlert('', 'Input all required details', 'error');
      return;
    }

    updateInvoice({
      order_id: bookOrderId,
      transporter_name: transporterName || '',
      lr_dispatch_details: transporterDetails || '',
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered id="ConfirmSummaryModal">
      <ModalBody className="p-0">
        <div className="bodyArea">
          <div className="modalHeader mb-0">
            <div className="title">DISPATCH DETAILS</div>
            <div className="closeButton">
              <img src={modalclose} alt="close" onClick={toggle} />
            </div>
          </div>
          <div className="dispatchDetails">
            <div>
              <Label htmlFor="TransporterName">Transporter Name</Label>
              <br />
              <UserInput
                value={transporterName}
                onChange={(e) => setTransporterName(e.target.value)}
                name="TransporterName"
                placeholder="Type Here"
              />
            </div>
            <div>
              <Label htmlFor="lrDetails">LR Details/Dispatch Details</Label>
              <br />
              <UserInput
                value={transporterDetails}
                onChange={(e) => setTransporterDetails(e.target.value)}
                name="lrDetails"
                placeholder="Type Here"
              />
            </div>
          </div>
        </div>
        <div className="submitButtonHolder">
          <button className="customButton customButton_blue" onClick={submit}>
            Submit
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UpdateDispatchDetails;
